
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";

import { HttpClient } from "@angular/common/http";
import { find, orderBy } from "lodash";
import { Observable } from "rxjs";
import { environment as env } from "../../../../environments/environment";

export interface AttachmentCategory {
    id: number;
    name: string;
}

@Injectable()
export class AttachmentLookupService {

    constructor(private http: HttpClient) { }

    public getAttachmentCategories(): Observable<AttachmentCategory[]> {
        const url = `${env.apiPath}/ui/lookup/FILE_ATTACHMENT_TYPE_DROPDOWN`;
        return this.http.get(url).pipe(
            map((res) => {
                return orderBy((res as any)[0].values.map((value) => {
                    return {
                        name: value.value,
                        id: value.valueId,
                    };
                }), "name");
            }));
    }

    public getAttachmentValue(id, attachmentTypes: AttachmentCategory[]): string {
        if (!attachmentTypes.length) {
            return "Loading...";
        }

        const type = find(attachmentTypes, (t) => Number(t.id) === Number(id));

        return id !== null && type ? type.name : "";
    }
};
